
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import Tip from "./component/tip.vue";
import { taxRateRules } from "@common/src/utils/verify";

const setting = namespace("setting");
const app = namespace("app");
const base = namespace("base");
@Component({
  components: { Tip }
})
export default class ManagementMode extends Vue {
  @setting.Action setOrderMode;
  @base.Action getSessionExtInfo;
  @app.State appType;
  modeFromData: any[] = [
    {
      code: "3",
      enable: false,
      inventory: "1",
      inboundProductTaxMode: "ALL_TAX_INCLUDED", // 入库商品
      purchaseTaxRate: 0, // 税率
      index: 0,
      assignTaskModeCode: "0",
      fifoStatus: "",
      productionBatchNoStatus: "0"
    },
    {
      code: "1",
      enable: false,
      inventory: "2",
      inboundProductTaxMode: "ALL_TAX_INCLUDED", // 入库商品
      purchaseTaxRate: 0, // 税率
      index: 1,
      assignTaskModeCode: "0",
      fifoStatus: "",
      productionBatchNoStatus: "0"
    }
  ];
  activeIndex: number = 0;
  currentIndex: number = 0;
  btnDisable: boolean = true;
  created() {
    this.setCurrentMode();
  }
  setCurrentMode() {
    this.getSessionExtInfo().then(data => {
      let activeData = this.modeFromData.find(item => {
        return item.code === data.orderModelCode;
      });
      activeData.enable = true;
      activeData.inventory = data.inventoryModelCode;
      activeData.assignTaskModeCode = data.assignTaskModeCode;
      activeData.fifoStatus = data.fifoStatus;
      activeData.productionBatchNoStatus = data.productionBatchNoStatus || "0";
      // activeData.purchaseTaxRate = data.purchaseTaxRate ?? "0";
      // activeData.inboundProductTaxMode = data.inboundProductTaxMode ?? "ALL_TAX_INCLUDED";
      this.currentIndex = activeData.index;
      this.activeIndex = activeData.index;
      this.modeFromData.forEach(o => {
        o.purchaseTaxRate = data.purchaseTaxRate ?? "0";
        o.inboundProductTaxMode = data.inboundProductTaxMode ?? "ALL_TAX_INCLUDED";
      });
    });
  }
  modeFromRules: any = {
    fifoStatus: [{ required: true, message: t("v216_g.fifo_required_message"), trigger: "blur" }]
    // purchaseTaxRate: [{ required: true, validator: this.validateRate, trigger: "blur" }]
  };
  validateRate(rule, value, callback) {
    if (value === "") {
      callback(new Error(this.$t("base.please-input") as string));
    } else {
      const checkResult = taxRateRules(value, callback);
      if (!checkResult.success) {
        return callback(new Error(checkResult.msg));
      } else {
        callback();
      }
    }
  }
  handleModeChange() {
    console.log("输入");
    const enable = this.modeFromData.some(item => item.enable);
    enable ? (this.btnDisable = false) : (this.btnDisable = true);
  }
  handleEnableChange(value, index) {
    this.modeFromData.forEach(item => {
      item.enable = false;
    });
    this.modeFromData[index].enable = value;
    this.activeIndex = index;
    value ? (this.btnDisable = false) : (this.btnDisable = true);
    if (value) {
      const from = (index + 1) % 2;
      console.log(from, index);
      this.modeFromData[index].fifoStatus = this.modeFromData[from].fifoStatus;
      this.modeFromData[index].productionBatchNoStatus = this.modeFromData[from].productionBatchNoStatus;
    }
  }

  async submitForm() {
    const formRef = this.$refs[`customerForm${this.activeIndex}`] as any;
    await formRef.validate();
    this.setOrderMode({
      inventoryModelCode: this.modeFromData[this.activeIndex].inventory,
      orderModelCode: this.modeFromData[this.activeIndex].code,
      assignTaskModel: this.modeFromData[this.activeIndex].assignTaskModeCode,
      fifoStatus: this.modeFromData[this.activeIndex].fifoStatus,
      purchaseTaxRate: this.modeFromData[this.activeIndex].purchaseTaxRate,
      inboundProductTaxMode: this.modeFromData[this.activeIndex].inboundProductTaxMode,
      productionBatchNoStatus: this.modeFromData[this.activeIndex].productionBatchNoStatus
    })
      .then(
        () => {
          this.$message.success(t("setting.managed-mode-saved-successfully"));
          this.currentIndex = this.activeIndex;
        },
        () => {
          this.modeFromData[this.activeIndex].enable = false;
        }
      )
      .finally(() => {
        this.setCurrentMode();
      });
  }
}
